/* eslint-disable */
// FIXME - Refactor this file
import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Button from 'components/Button';
import Spinner from 'components/Spinner';
import { TopBar } from 'legacyComponents/layout/topBar';
import { ToggleButton } from 'legacyComponents/buttons/toggleButton';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { TopicCard } from 'legacyComponents/cards/types/topic';
import { ProfileCard } from 'legacyComponents/cards/types/profile';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { ThreadCard } from 'legacyComponents/cards/types/thread';
import { StoryCard } from 'legacyComponents/cards/types/story';
import { CollectionCard } from 'legacyComponents/cards/types/collection';

import { headerStore } from 'apps/components/header/app';
import Header from 'apps/components/header/header';

import Lottie from 'react-lottie'
import wfLoader from 'assets/lotties/wf-loader-black.json';

import { Loading } from 'libs/rendering/gltf/components/loading';

import styled from 'styled-components';
import { MainWrapper, Center } from 'legacyComponents/styled/lib';

@withNamespaces()
@inject('routerStore', 'searchManager')
@observer
export class SearchPage extends React.Component {
  render() {
    const { t, searchManager } = this.props;
    
    const search = headerStore.searchedTerm === '' ? this.props.params.get('q') : headerStore.searchedTerm;

    const channels = searchManager.channelsConn.arrayApp;
    const initiatives = searchManager.initiativesConn.arrayApp;
    const profiles = searchManager.profilesConn.arrayApp;
    const projects = searchManager.projectsConn.arrayApp;
    const posts = searchManager.threadsConn.arrayApp;
    const stories = searchManager.storiesConn.arrayApp;
    const collections = searchManager.collectionsConn.arrayApp;

    const {
      loading,
      resultFilter,
      totalMatchCount,
      matchedTypes,
      matchedAndFilteredTypes,
      SetResultFilter,
    } = searchManager;

    const title = totalMatchCount > 0 ? (
        <Trans count={totalMatchCount}>
          {{ totalMatchCount }} Result for {{ search }}
        </Trans>
      ) : (
        <Trans>No Results for {{ search }}.</Trans>
      );

    if (loading) {
      return (
        <>
          <Header />
          <Loading visible noText />
        </>
      )
    }

    const defaultOptions = {
      loop: true,
      autoplay: true,
      renderer: 'svg',
      animationData: wfLoader,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      }
    };

    return (
      <div>
        <Header />
        <TopBar>
          <Title name='search-title'>{title}</Title>
        </TopBar>
        <MainWrapper>
          <Center>
            {loading ? (
              <Lottie
                options={defaultOptions}
                height={60}
                width={60} />
            ) : matchedTypes.length > 1 ? (
              <ToggleButton
                buttons={[['none', t('Everything')], ...matchedTypes]}
                activeButton={resultFilter}
                handleClick={SetResultFilter}
                margin='20px 0px 0px 0px'
              />
            ) : '' }
          </Center>
          {loading ? null : (
            <SectionWrapper>
              {((channels.length > 0 && resultFilter === 'none') ||
              matchedAndFilteredTypes[0] === 'channels') && (
                <CardSection
                  invisible={searchManager.loading}
                  title={t('Topics')}
                  isOwnProfile={false}
                  ownerName=''
                  cardApp={channels}
                  CardComponent={TopicCard}
                  gridColumns={channels.length > 0 && 3}
                />
              )}
              {((initiatives.length > 0 && resultFilter === 'none') ||
              matchedAndFilteredTypes[0] === 'initiatives') && (
                <CardSection
                  invisible={searchManager.loading}
                  title={t('Organisations')}
                  isOwnProfile={false}
                  ownerName=''
                  cardApp={initiatives}
                  CardComponent={ProfileCard}
                  gridColumns={initiatives.length > 0 && 3}
                />
              )}
              {((profiles.length > 0 && resultFilter === 'none') ||
              matchedAndFilteredTypes[0] === 'profiles') && (
                <CardSection
                  invisible={searchManager.loading}
                  title={t('Profiles')}
                  isOwnProfile={false}
                  ownerName=''
                  cardApp={profiles}
                  CardComponent={ProfileCard}
                  gridColumns={profiles.length > 0 && 4}
                />
              )}
              {((projects.length > 0 && resultFilter === 'none') ||
              matchedAndFilteredTypes[0] === 'projects') && (
                <CardSection
                  invisible={searchManager.loading}
                  title={t('Projects')}
                  isOwnProfile={false}
                  ownerName=''
                  cardApp={projects}
                  CardComponent={ProjectCard}
                  gridColumns={projects.length > 0 && 3}
                />
              )}
              {((posts.length > 0 && resultFilter === 'none') ||
              matchedAndFilteredTypes[0] === 'threads') && (
                <CardSection
                  invisible={searchManager.loading}
                  title={t('Threads')}
                  isOwnProfile={false}
                  ownerName=''
                  cardApp={posts}
                  CardComponent={ThreadCard}
                />
              )}
              {((stories.length > 0 && resultFilter === 'none') ||
              matchedAndFilteredTypes[0] === 'stories') && (
                <CardSection
                  invisible={searchManager.loading}
                  title={t('Stories')}
                  isOwnProfile={false}
                  ownerName=''
                  cardApp={stories}
                  CardComponent={StoryCard}
                  gridColumns={stories.length > 0 && 2}
                />
              )}
              {((collections.length > 0 && resultFilter === 'none') ||
              matchedAndFilteredTypes[0] === 'collections') && (
                <CardSection
                  invisible={searchManager.loading}
                  title={t('Collections')}
                  isOwnProfile={false}
                  ownerName=''
                  cardApp={collections}
                  CardComponent={CollectionCard}
                  gridColumns={collections.length > 0 && 3}
                />
              )}
            </SectionWrapper>
          )}
        </MainWrapper>
      </div>
    );
  }
}

SearchPage.propTypes = {
  params: PropTypes.object,
  t: PropTypes.func,
};

const Title = styled.h2`
  text-align: center;
  margin: auto;
  font-size: ${props => props.theme.font.size.medium};
`;

const SectionWrapper = styled.div`
  margin: 0 0 60px 0;
`;

const ButtonStyled = styled(Button)`
  margin-top: ${props => props.theme.spacing.medium};
`;
